const CALENDAR_APPEARANCES = ['list', 'compact', 'birthday'];

export { CALENDAR_APPEARANCES };
